import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from 'src/components/button';
import styles from './application-status-card.module.scss';
import {PLANNING_TO_APPLY, UNDECIDED} from 'shared/college-application-status/utils';

const propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  setCollegeAppStatus: PropTypes.func.isRequired,
  logoImage: PropTypes.string,
};

class ApplicationStatusCard extends React.Component {
  markAsPlanningToApply = () => {
    this.props.setCollegeAppStatus(this.props.id, PLANNING_TO_APPLY);
  };

  markAsUndecided = () => {
    this.props.setCollegeAppStatus(this.props.id, UNDECIDED);
  };

  render = () => {
    const {name, logoImage} = this.props;

    return (
      <div className={styles.card} data-testid="application-status-card">
        <div className={styles.top}>
          <img
            data-testid="logo-image"
            className={styles.logoImage}
            src={logoImage}
            alt={`${name} logo`}
          />
          <div className={styles.name}>{name}</div>
        </div>

        <div className={styles.bottom}>
          <Button
            className={styles.planToApplyButton}
            onClick={this.markAsPlanningToApply}
            margin={false}
            size="tiny"
            outline
            testId={`plan-to-apply-${name}`}
          >
            Plan to apply
          </Button>

          <Button
            className={styles.undecidedButton}
            onClick={this.markAsUndecided}
            margin={false}
            size="tiny"
            outline
            testId={`undecided-${name}`}
          >
            Undecided
          </Button>
        </div>
      </div>
    );
  };
}

// Card variant we show at end of list.
const Done = () => (
  <div className={classnames(styles.card, styles.done)} data-testid="application-status-done-card">
    <div>
      <span role="img" aria-label="party!">
        🎉
      </span>{' '}
      Done!
    </div>
  </div>
);

ApplicationStatusCard.propTypes = propTypes;

ApplicationStatusCard.Done = Done;

export default ApplicationStatusCard;
